export const REQUEST_GENERAL_VERIFICATION = "REQUEST_GENERAL_VERIFICATION";
export const GRANT_GENERAL_VERIFICATION = "GRANT_GENERAL_VERIFICATION";
export const REVOKE_GENERAL_VERIFICATION = "REVOKE_GENERAl_VERIFICATION";
export const RESET_GENERAL_VERIFICATION = "RESET_GENERAL_VERIFICATION";

export const REQUEST_FINALIZE_REGISTRATION = "REQUEST_FINALIZE_REGISTRATION";
export const GRANT_FINALIZE_REGISTRATION = "GRANT_FINALIZE_REGISTRATION";
export const REVOKE_FINALIZE_REGISTRATION = "REVOKE_FINALIZE_REGISTRATION";
export const RESET_FINALIZE_REGISTRATION = "RESET_FINALIZE_REGISTRATION";

export const REQUEST_INVITATION_REGISTRATION =
  "REQUEST_INVITATION_REGISTRATION";
export const GRANT_INVITATION_REGISTRATION = "GRANT_INVITATION_REGISTRATION";
export const REVOKE_INVITATION_REGISTRATION = "REVOKE_INVITATION_REGISTRATION";
export const RESET_INVITATION_REGISTRATION = "RESET_INVITATION_REGISTRATION";

export const REQUEST_CAN_REGISTER = "REQUEST_CAN_REGISTER";
export const GRANT_CAN_REGISTER = "GRANT_CAN_REGISTER";
export const REVOKE_CAN_REGISTER = "REVOKE_CAN_REGISTER";
export const RESET_CAN_REGISTER = "RESET_CAN_REGISTER";

export const REQUEST_NEW_SPACE_REGISTRATION = "REQUEST_NEW_SPACE_REGISTRATION";
export const GRANT_NEW_SPACE_REGISTRATION = "GRANT_NEW_SPACE_REGISTRATION";
export const REVOKE_NEW_SPACE_REGISTRATION = "REVOKE_NEW_SPACE_REGISTRATION";
export const RESET_NEW_SPACE_REGISTRATION = "RESET_NEW_SPACE_REGISTRATION";

export const REQUEST_RESUBSCRIBE_REGISTRATION =
  "REQUEST_RESUBSCRIBE_REGISTRATION";
export const GRANT_RESUBSCRIBE_REGISTRATION = "GRANT_RESUBSCRIBE_REGISTRATION";
export const REVOKE_RESUBSCRIBE_REGISTRATION =
  "REVOKE_RESUBSCRIBE_REGISTRATION";
export const RESET_RESUBSCRIBE_REGISTRATION = "RESET_RESUBSCRIBE_REGISTRATION";
